import { render, staticRenderFns } from "./oz-icon.vue?vue&type=template&id=1dea3890&scoped=true&"
import script from "./oz-icon.vue?vue&type=script&lang=ts&"
export * from "./oz-icon.vue?vue&type=script&lang=ts&"
import style0 from "./oz-icon.vue?vue&type=style&index=0&id=1dea3890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea3890",
  null
  
)

/* custom blocks */
import block0 from "./oz-icon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports